<div class="m-motive-editor">
  @for (motive of motives(); track motive.id) {
  <div class="m-motive-editor__card">
    <!-- Delete button - appears on hover -->
    <button
      type="button"
      class="m-motive-editor__delete-btn"
      (click)="onDeleteMotive(motive.id)"
      [title]="'COMMON.DELETE' | translate"
    >
      <mat-icon class="m-motive-editor__icon-small">delete</mat-icon>
    </button>

    <!-- Main motive fields -->
    <div class="m-motive-editor__fields">
      <div class="m-motive-editor__field">
        <label class="m-motive-editor__label">{{ 'EVALUATION.MOTIVE_TITLE' | translate }}</label>
        <input
          type="text"
          [value]="motive.title"
          (input)="onMotiveFieldChange(motive.id, 'title', $any($event.target).value)"
          class="m-motive-editor__input"
          [placeholder]="'EVALUATION.MOTIVE_PLACEHOLDER' | translate"
        />
      </div>
      <div class="m-motive-editor__field">
        <label class="m-motive-editor__label">{{ 'EVALUATION.KEY_SF' | translate }}</label>
        <input
          type="text"
          [value]="motive.title_key_SF"
          (input)="onMotiveFieldChange(motive.id, 'title_key_SF', $any($event.target).value)"
          class="m-motive-editor__input m-motive-editor__input--mono"
          placeholder="CLE_SF"
        />
      </div>
    </div>

    <!-- Sub-motives -->
    @if (motive.subMotives && motive.subMotives.length > 0) {
    <div class="m-motive-editor__submotives">
      @for (subMotive of motive.subMotives; track subMotive.id) {
      <div class="m-motive-editor__submotive">
        <input
          type="text"
          [value]="subMotive.title"
          (input)="
            onSubMotiveFieldChange(motive.id, subMotive.id, 'title', $any($event.target).value)
          "
          class="m-motive-editor__submotive-input"
          placeholder="Titre sous-motif"
        />
        <input
          type="text"
          [value]="subMotive.title_key_SF"
          (input)="
            onSubMotiveFieldChange(
              motive.id,
              subMotive.id,
              'title_key_SF',
              $any($event.target).value
            )
          "
          class="m-motive-editor__submotive-input m-motive-editor__submotive-input--mono"
          placeholder="Clé SF"
        />
        <button
          type="button"
          (click)="onDeleteSubMotive(motive.id, subMotive.id)"
          class="m-motive-editor__submotive-delete"
          [title]="'COMMON.DELETE' | translate"
        >
          <mat-icon class="m-motive-editor__icon-small">close</mat-icon>
        </button>
      </div>
      }
    </div>
    }

    <!-- Add sub-motive button -->
    <button
      type="button"
      class="m-motive-editor__add-submotive"
      (click)="onAddSubMotive(motive.id)"
    >
      <mat-icon>add</mat-icon>
      {{ 'EVALUATION.ADD_SUB_MOTIVE' | translate }}
    </button>
  </div>
  }

  <!-- Add motive button -->
  <button type="button" class="m-motive-editor__add-motive" (click)="onAddMotive()">
    <mat-icon>add</mat-icon>
    {{ 'EVALUATION.ADD_MOTIVE' | translate }}
  </button>
</div>
